import {request, requestLogin} from "../../../utils/apiUtils";
import {URL_API} from "../../../url.config";

let DiemDanhController = {

    diemDanh: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/diemdanh`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    diemDanhList: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/diemdanh/list`,
            method: 'POST',
            body: payload
        }, callback);
    }
}

export default DiemDanhController
